<mat-dialog-content>
	<ng-container [formGroup]="formGroup">
		<div class="d-flex flex-row gap-2">
			<mat-form-field appearance="outline">
				<mat-label>Zwrot grzecznościowy</mat-label>
				<mat-select formControlName="sex" placeholder="Pan">
					<mat-option value="M">Pan</mat-option>
					<mat-option value="F">Pani</mat-option>
				</mat-select>
				<mat-error>To pole jest wymagane</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Imię</mat-label>
				<input type="text" matInput formControlName="firstName" />
				<mat-error>To pole jest wymagane</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Nazwisko</mat-label>
				<input type="text" matInput formControlName="lastName" />
				<mat-error>To pole jest wymagane</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" class="example-form-field">
				<mat-label>Data urodzenia</mat-label>
				<input matInput [matDatepicker]="datepicker" formControlName="birth" />
				<mat-hint>MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
				<mat-datepicker #datepicker>
					<mat-datepicker-actions>
						<button mat-button matDatepickerCancel>Anuluj</button>
						<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
					</mat-datepicker-actions>
				</mat-datepicker>
				<mat-error>To pole jest wymagane</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Obywatelstwo</mat-label>
				<mat-select formControlName="nationality">
					<mat-option *ngFor="let nationality of nationalities" [value]="nationality.id">{{
						nationality.name
					}}</mat-option>
				</mat-select>
				<mat-error> To pole jest wymagane</mat-error>
			</mat-form-field>
		</div>
		<div class="d-flex flex-row gap-2 mt-1 flex-nowrap ownerData_secondColumn">
			<mat-form-field appearance="outline" class="flex-fill">
				<mat-label>Adres e-mail</mat-label>
				<input type="text" matInput formControlName="email" />
				<mat-error>
					<ng-container *ngIf="controlFilledIncorrectly('email'); else empty">
						Wprowadź poprawny adres email
					</ng-container>
					<ng-template #empty> To pole jest wymagane</ng-template>
				</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" class="flex-fill">
				<mat-label>Numer telefonu (z numerem kierunkowym)</mat-label>
				<input
					matInput
					type="text"
					placeholder="Numer telefonu (z numerem kierunkowym)"
					formControlName="phoneNumber"
				/>
				<mat-error>
					<ng-container *ngIf="controlFilledIncorrectly('phoneNumber'); else empty">
						Wprowadź poprawny numer telefonu
					</ng-container>
					<ng-template #empty> To pole jest wymagane</ng-template>
				</mat-error>
			</mat-form-field>
		</div>
	</ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button (click)="cancel()">Porzuć</button>
	<button mat-raised-button color="primary" (click)="submit()">Zapisz zmiany</button>
</mat-dialog-actions>
